import type { ChangeEvent, SetStateAction } from 'react';
import { useCallback, useState } from 'react';

export const useInputValue = (
    initialState: string | (() => string)
): [
    string,
    (event: ChangeEvent<HTMLInputElement>) => void,
    (value: SetStateAction<string>) => void
] => {
    const [value, setValue] = useState(initialState);
    const onInputChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    }, []);

    return [value, onInputChange, setValue];
};
